import { Pipe, PipeTransform } from "@angular/core";
import { Message } from "@handshake/core-types";

@Pipe({
  name: "filterMessage",
})
export class FilterMessagePipe implements PipeTransform {
  transform(value: Message[], id: string): Message[] {
    if (id === "ALL") {
      return value;
    }
    if (!value) {
      return null;
    }
    return value?.filter((message) => {
      if (message.milestoneId === id) {
        return true;
      }
      if (message.request?.metadata?.isSubmilestone && message.request.metadata?.subMilestoneId === id) {
        return true;
      }
      return false;
    });
  }
}
